import { ChevronLeft, ChevronRight } from "lucide-react";
import styles from "./PaginationControls.module.css";
import { usePagination } from "./usePagination";
import { DOTS, type paginationControlsProps } from "./types.props";

const PaginationControls = ({
    onPageChange,
    ...props
}: paginationControlsProps) => {
    const paginationRange = usePagination({ onPageChange, ...props });

    if (props.currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    const onNext = () => onPageChange(props.currentPage + 1);
    const onPrevious = () => onPageChange(props.currentPage - 1);

    const lastPage = paginationRange[paginationRange.length - 1];

    return (
        <nav
            aria-label="pagination"
            className={props.className}
        >
            <ul className={styles["pagination-container"]}>
                <li>
                    <button
                        type="button"
                        className={styles["pagination-item"]}
                        onClick={onPrevious}
                        disabled={props.currentPage === 1}
                        aria-label="Go to previous page"
                    >
                        <ChevronLeft size={20} />
                    </button>
                </li>
                {paginationRange.map((pageNumber, index) => {
                    if (pageNumber === DOTS) {
                        return (
                            <li
                                key={DOTS + index}
                                className={`${styles["pagination-item"]} ${styles["dots"]}`}
                            >
                                …
                            </li>
                        );
                    }

                    return (
                        <li key={pageNumber}>
                            <button
                                type="button"
                                className={`${styles["pagination-item"]} ${pageNumber === props.currentPage ? styles["selected"] : ""
                                    }`}
                                onClick={() => onPageChange(pageNumber as number)}
                                aria-current={
                                    pageNumber === props.currentPage ? "page" : undefined
                                }
                            >
                                {pageNumber}
                            </button>
                        </li>
                    );
                })}
                <li>
                    <button
                        type="button"
                        className={styles["pagination-item"]}
                        onClick={onNext}
                        disabled={props.currentPage === lastPage}
                        aria-label="Go to next page"
                    >
                        <ChevronRight size={20} />
                    </button>
                </li>
            </ul>
        </nav>
    );
};

export default PaginationControls;
